import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetContactFormValidation as GetContactFormValidationQuery,
    GetContactFormValidationVariables,
    ContactCreateValidationInput,
    GetContactFormValidation_contactCreateValidation as ContactCreateValidation,
} from 'nutshell-graphql-types';

import GET_CONTACT_FORM_VALIDATION from '../queries/get-contact-form-validation.graphql';

export const useGetContactFormValidation = (
    input?: ContactCreateValidationInput
): {
    contactCreateValidation: ContactCreateValidation | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: (input: ContactCreateValidationInput) => Promise<any>;
} => {
    const {
        data,
        error,
        loading: isLoading,
        refetch,
    } = useQuery<GetContactFormValidationQuery, GetContactFormValidationVariables>(
        GET_CONTACT_FORM_VALIDATION,
        {
            variables: {
                // @ts-expect-error
                input,
            },
            skip: !input,
        }
    );

    const contactCreateValidation = data ? data.contactCreateValidation : null;

    return {
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading,
        contactCreateValidation,
        refetch: (newInput: ContactCreateValidationInput) => refetch({input: newInput}),
    };
};
